import React from "react";
import styles from "./WhyChooseUsItem.module.css";

export const WhyChooseUsItem = ({ card: { title, text, icon: Icon } }) => {
  return (
    <div className={styles.card}>
      <Icon />
      <h3 className={styles.cardTitle}>{title}</h3>
      <p className={styles.cardText}>{text}</p>
    </div>
  );
};
